export const getRandomNumber = (min = 12, max = 15) => {
    return Math.random() * (max - min) + min;
  };

  export const getRandomNumberWithSymbol = (min = 12, max = 15) => {
    let result =  Math.random() * (max - min) + min
    return Math.floor(result)%2===0? result:  -result
  };
  export  const getRandomIntNumberWithSymbol = (min = 12, max = 15) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    let result =  Math.floor(Math.random() * (max - min) + min)
    return result%2===0? result:  -result
  };